export const isPermissionDeniedError = (error: any) => {
  return error.code && error.code === "permission-denied";
};
